import { Component, Input, OnChanges } from '@angular/core';

import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { FilterTextComponent } from '../filterText/filter-text.component';
import { FilterTypeSingleTextModel } from '../../models/filter-type-single-text.model';

@Component({
    selector: 'agpr-filter-single-text',
    templateUrl: '../filterText/filter-text.component.html',
    styleUrls: ['../filterText/filter-text.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: FilterSingleTextComponent
        }
    ],
    standalone: false
})
export class FilterSingleTextComponent extends FilterTextComponent implements OnChanges {
    @Input() declare filter: FilterTypeSingleTextModel;

    value: string[];
    searchQuery: string;

    readonly buttonStyles = ButtonTypesEnum;

    ngOnChanges(): void {
        this.searchQuery = '';
        this.refresh();
    }

    /**
     * Refreshes the current value from the filter
     */
    refresh(): void {
        this.value = this.filter.getCurrentValue();
    }

    /**
     * Updates the current value of the filter
     */
    handleChange(): void {
        this.filter.setCurrentValue(this.value);
    }

    /**
     * Adds a search query if it did not previously exist
     */
    search(): void {
        if (this.filter.prefix && this.searchQuery.indexOf(this.filter.prefix) !== 0) {
            this.searchQuery = this.filter.prefix + this.searchQuery;
        }
        if (this.filter.canAddCurrentItem(this.searchQuery)) {
            this.value = [this.searchQuery];
            this.filter.setCurrentValue(this.value);
            this.searchQuery = '';
        }
    }
}
